<!--积分扣除组件引用文件
    global_hotWord/global_hotWord.vue,
    resource/resource_list.vue 
-->
<template>
    <div  class="deduct-dialog">
        <el-dialog
            title="提示"
            :visible.sync="isShowTip"
            width='450px'
            :before-close="handleClose">
            <div v-html="scoreMsg"></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose"  class="cancel-btn">关闭</el-button>
                <el-button @click="sureTip" type="primary" class="medical-btn">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {checkScoreStatus,isDeductScore,logout} from '../../io/api.js'

import {clearAllCookie, getCookieInfo} from '../../io/getCookie.js'
export default {
    props:{
        cancel:{
            type: String,
        },
        ok:{
            type: String,
        },
        show:{
            type: Boolean,
        }, 
        flag:{
            type: String,
        },
         
    },
    data() {
        return {
            isShowTip:false,
            scoreMsg:'',
            searchWord:'',
            scoreType:'',
            scoreItem:{},
        }
    },
    mounted() {

    },
    methods: {
        //查询扣除积分
        get_checkScoreStatus(item,searchWord){
            const token = localStorage.getItem('token') || getCookieInfo('access_token') || '';
            if (!token) {
                this.$message.warning('请先登录~');
                this.$emit('update:show', false);
                return;
            }
            this.searchWord=searchWord; 
            this.scoreMsg='';
            this.scoreItem=item;
            let params={
                id: this.scoreItem.Tid,
                link:this.scoreItem.link,
                table: this.scoreItem.table,
                searchWord:this.searchWord?this.searchWord:this.$route.query.word||'',
            }
            isDeductScore(params).then(res=>{
                let {code,msg,data} =res.data;
                if(code==0){
                    this.scoreMsg='';
                    this.scoreType=data.type;
                    if(this.scoreType=='already'){
                        this.toPill(this.scoreItem)
                        return
                    }else if(this.scoreType=='zero_score'){ 
                        this.scoreMsg='积分不足请联系管理员' 
                    }else if(this.scoreType=='institutional_personal_expire'){ 
                        this.scoreMsg='机构积分和个人积分已过期' 
                    }else if(this.scoreType=='personal_expire'){
                        this.scoreMsg='个人积分已过期'  
                    }else if(this.scoreType=='institution'){
                        this.scoreMsg=`扣除机构<b> ${data.score}</b> 积分`; 
                    }else if(this.scoreType=='person'){
                        this.scoreMsg=`扣除个人<b> ${data.score}</b> 积分`; 
                    }else if(this.scoreType=='institution_disable_person_disable'){
                        this.scoreMsg=`机构和个人用户已停用，请联系管理员!`; 
                    }else if(this.scoreType=='institution_expire_person_disable'){
                        this.scoreMsg=`机构过期，个人用户已停用，请联系管理员!`; 
                    }else if(this.scoreType=='institution_no_score_person_disable'){
                        this.scoreMsg=`机构积分不足，个人用户已停用，请联系管理员!`; 
                    }else if(this.scoreType=='person_disable'){
                        this.scoreMsg=`个人用户已停用，请联系管理员!`; 
                    } else if(this.scoreType=='status_disable'){
                        this.scoreMsg=`账号已被封禁!`; 
                    } 
                    this.isShowTip=true; 
                }else{
                    this.$message.error(msg||'请求失败～')
                }
            })
        },
        //确定扣除积分
        sureTip(item){
            if(this.scoreType=='zero_score'||this.scoreType=='institutional_personal_expire'||this.scoreType=='personal_expire'){ 
                this.isShowTip=false;
                return
            }else if(this.scoreType=='status_disable'){
                this.isShowTip=false;
                window.localStorage.clear();
			    window.sessionStorage.clear();
                clearAllCookie();
                logout().then(res=>{ 
                    let data = res.data;
                    if(data&&data.code==0){ 
                        window.open(`${window.location.origin}/knowservePlatform/homePage`, "_self");	
                    }else{
                        this.$message.error(data.msg);
                    }
                })
                return
            }
            let params={
                id: this.scoreItem.Tid,
                link:this.scoreItem.link,
                table: this.scoreItem.table,
                searchWord:this.searchWord?this.searchWord:this.$route.query.word||'',
            }
            checkScoreStatus(params).then(res=>{
                let {code,msg,data} =res.data;
                if(code==0){   
                    if(data.type=='institution'){ 
                        this.$store.state.institutionalScore=this.$store.state.institutionalScore-data.score;
                    }else if(data.type=='person'){
                        this.$store.state.personalScore=this.$store.state.personalScore-data.score;
                    }
                    this.toPill(this.scoreItem)
                    
                }else{
                    this.$message.error(msg||'请求失败～')
                } 
                this.isShowTip=false;
            })
        },
        toPill(item){
            let query={
                word:this.searchWord,
                flag:this.flag,
            };
            let url= this.$router.resolve({
                path:'pill',
                query,
            }) 
            //放到query里太长了，所以用localStorage传值，pill页面接口是使用
            window.localStorage.setItem('globalRow',JSON.stringify(item))
            this.$windowOpen({ url:url.href,isLogin:true} )
        }, 
        handleClose() {
            this.$emit('update:show',false)
            this.isShowTip=false;
            this.scoreMsg='';
            this.searchWord='';
            this.scoreType='';
            this.scoreItem={}; 
        },
    },
}
</script>

<style lang='less' scoped>
.deduct-dialog{
    ::v-deep .el-dialog__header{
        line-height: 24px; 
        font-size: 18px;
        padding: 10px 20px;
        // .el-dialog__title{
        //     color: #fff;
        // }
    }
    ::v-deep  .el-dialog__header{
        line-height: 24px; 
        font-size: 18px;
        padding: 10px 20px;
        // .el-dialog__title{
        //     color: #fff;
        // }
    }

    ::v-deep .el-dialog__headerbtn{
        top:12px;
        // .el-dialog__close{
        //     color: #fff !important;
        // }
    } 
    ::v-deep .el-dialog__body{
        padding: 20px !important;
    }
    ::v-deep .el-dialog__footer{
        padding-top: 0;
    }
}
</style>